import React from 'react'
import { Checkbox } from 'antd-mobile-v5'

const Agreement = ({ checked, setChecked, children }) => {
  return (
    <Checkbox
      style={{
        '--icon-size': '16px',
        '--font-size': '13px',
        '--gap': '6px',
        color: '#333333',
        display: 'flex',
        alignItems: 'flex-start',
        margin: '0 15px',
      }}
      checked={checked}
      onChange={(val) => setChecked(val)}
    >
      {children}
    </Checkbox>
  )
}

export default Agreement
